"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.form.title.edit': 'Modifica Passo',
    'step.form.title.add': 'Aggiungi Passo',
    'step.form.back': 'Indietro',
    'step.form.title.label': 'Titolo',
    'step.form.title.placeholder': 'Titolo del passo',
    'step.form.order.label': 'Ordine',
    'step.form.order.placeholder': 'Ordine del passo',
    'step.form.isShared.label': 'Passo Condiviso',
    'step.form.profession.label': 'Professione',
    'step.form.profession.placeholder': 'Seleziona professione',
    'step.form.description.label': 'Descrizione',
    'step.form.description.placeholder': 'Descrizione',
    'step.form.questions.title': 'Domande',
    'step.form.questions.add': 'Aggiungi Domanda',
    'step.form.questions.remove': 'Rimuovi',
    'step.form.questions.empty': 'Nessuna domanda aggiunta ancora. Clicca "Aggiungi Domanda" per iniziare.',
    'step.form.questions.order': 'Domanda',
    'step.form.submit.update': 'Aggiorna Passo',
    'step.form.submit.create': 'Crea Passo',
};
